import React from 'react';
import { pick } from 'lodash';

type Props = {
  url: string;
  closeIframe: () => void;
  attrs: any;
};
const Validate3DS2: React.FC<Props> = (props) => {
  if (!props.url) {
    return <React.Fragment />;
  }
  const { attrs } = props;
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
      }}
    >
      <iframe
        title="Verify 3DS2 page"
        src={props.url}
        width="100%"
        height="100%"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        security="allow-scripts allow-popups"
        style={{ border: 'none' }}
      />
      <button
        style={{
          ...pick(attrs.submitButton, ['backgroundColor', 'color']),
          borderRadius: attrs.borderRadius,
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: 45,
        }}
        onClick={() => {
          props.closeIframe();
        }}
      >
        Close
      </button>
    </div>
  );
};
export default Validate3DS2;
